<template>
  <div class="breadcrumb">
    <v-breadcrumbs v-if="items" :items="items"></v-breadcrumbs>
  </div>
</template>
<script>
export default {
  name: "Breadcrumbs",
  data() {
    return {
      items: [
       
      ],
    };
  },

  watch: {
    "$route.meta":  async function () {
      this.items = []; //clear the list
      if(!this.$route.meta.breadcrumbs) return;
      this.$route.meta.breadcrumbs.map(b => {
        // get the actual route from index by using that name
        var route = this.$router.options.routes.find((r) => r.name == b);
        if(!route) return;
        // console.log(route);
        this.items.push({
          text: route.meta.title,
          to: route,
          exact: true,
        });
      });
    },
  },
};
</script>

<style lang="css" scoped>
.v-breadcrumbs {
  padding-bottom: 0px;
}
</style>